// extracted by mini-css-extract-plugin
export default {"strikeout":"---------packages-corgi-x-src-components-Strikeout-Strikeout-module__strikeout"};